$(document).ready(function(){
    $(".testimonial-carousel").owlCarousel({
        center: true,
        margin:30,
        loop:true,
        nav:true,
        navText : ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>'],
        autoWidth: true,
        responsive : {
            0: {items:1}
        }


    });
  });